<template>
  <div class="table__filters">
    <div class="table__filters__title">
      <v-icon color="gray-6" small>filter_list</v-icon>
      {{ $t('Common.filters') }}
    </div>

    <div class="table__filters__item">
      <FormTextField
        v-model="filters.search"
        :name="$t(`${namespace}.table.filters.searchPlaceholder`)"
        :placeholder="$t(`${namespace}.table.filters.searchPlaceholder`)"
        :disabled="isLoading"
        :loading="isLoading"
        prepend-icon="search"
        clearable
        small
        @reset="reset"
      />
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'

export default {
  name: 'TableFilters',
  props: {
    status: {
      type: Number,
      default: STATUS_IS_LOADING
    }
  },
  computed: {
    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    },

    searchIsLoading () {
      return this.isLoading && Boolean(this.filters.search)
    }
  },
  data () {
    return {
      namespace: 'Views.EmployeesPage',
      filters: {
        search: null
      }
    }
  },
  methods: {
    emitChangeEvent () {
      this.$emit('change', this.filters)
    },

    handleSearch: debounce(function () {
      this.emitChangeEvent()
    }, 1000),

    reset () {
      this.filters.search = ''
      this.emitChangeEvent()
    }
  },
  watch: {
    'filters.search' (val) {
      if (!val) {
        this.reset()
        return
      }

      this.handleSearch()
    }
  }
}
</script>
